import React, { FC, MouseEventHandler } from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import { FontAwesomeIcon } from 'components/shared/Icon/FontAwesome';
import Search from 'components/shared/Icon/icons/Search';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import cs from '../../index.module.css';
import useIconPicker from './functions';
import s from './index.module.css';
import { IIconPicker, IIconPickerOption } from './types';

// Todo: Update file after complete improvedUIOnEventModalsFeature
const IconPicker: FC<IIconPicker> = ({ name, control, eventType, isImprovedUIOnEventModalsFeature = false }) => {
  const { value, onChange, sortedIcons, favoriteIconsList, handleFavoriteIcon, handleIconSearchModal } = useIconPicker({
    name,
    control,
    eventType,
    isImprovedUIOnEventModalsFeature,
  });

  if (isImprovedUIOnEventModalsFeature) {
    return (
      <div className={s.wrapper}>
        <div className={s.searchLink}>
          <Icon component={Search} />
          <button type="button" onClick={handleIconSearchModal}>
            Search More Icons
          </button>
        </div>
        <div className={s.options}>
          {sortedIcons.map((icon) => (
            <IconPickerOption
              name={name}
              key={icon}
              icon={icon}
              isSelected={value === icon}
              onSelectChange={onChange}
              isFavorite={favoriteIconsList.includes(icon)}
              onFavoriteChange={handleFavoriteIcon}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      <IconPickerHeader onClick={handleIconSearchModal} />
      <div className={s.options}>
        {sortedIcons.map((icon) => (
          <IconPickerOption
            name={name}
            key={icon}
            icon={icon}
            isSelected={value === icon}
            onSelectChange={onChange}
            isFavorite={favoriteIconsList.includes(icon)}
            onFavoriteChange={handleFavoriteIcon}
          />
        ))}
      </div>
    </>
  );
};

const IconPickerHeader = ({ onClick }: { onClick: MouseEventHandler }) => (
  <div className={cx(cs.title, cs.noPaddingTop, s.headerWrapper)}>
    Event Icon
    <div className={s.searchLink}>
      <Icon component={Search} />
      <button type="button" onClick={onClick}>
        Search More Icons
      </button>
    </div>
  </div>
);

const IconPickerOption: FC<IIconPickerOption> = ({
  name,
  icon,
  isFavorite,
  isSelected,
  onFavoriteChange,
  onSelectChange,
}) => {
  const { isTabletOrMobile } = useMediaBreakpoints();
  return (
    <label>
      <input type="radio" name={name} value={icon} checked={isSelected} onChange={onSelectChange} />
      <div className={cx(s.icon, isFavorite && s.favorite)}>
        <FontAwesomeIcon key={icon} className={icon} />
        <button
          type="button"
          className={s.favoriteButton}
          onClick={() => onFavoriteChange(icon)}
          disabled={isTabletOrMobile}
        >
          <FontAwesomeIcon className="fa-regular fa-star" />
        </button>
      </div>
    </label>
  );
};

export default IconPicker;
